import React from 'react';
import { Card, CardActions, CardHeader, CardText} from 'material-ui/Card'
import RaisedButton from 'material-ui/RaisedButton'
import TextField from 'material-ui/TextField';
import PhoneIcon from 'material-ui/svg-icons/communication/phone';
import PinDrop from 'material-ui/svg-icons/maps/pin-drop';
import DetailsIcon from 'material-ui/svg-icons/action/subject';
import ContentLinkIcon from 'material-ui/svg-icons/content/link';
import AutoComplete from 'material-ui/AutoComplete';
import {fetchWithAuth} from '../../util/fetch';
import {EndpointURL} from '../../constants';
import {connect} from 'react-redux';
import {AddLocationEpic} from '../../actions/location.actions';
import {LoadCountriesEpic} from '../../actions/reference.actions';

class AddRestaurant extends React.Component {

    constructor(props){
      super(props);
      this.state = { companyOptions: []};
      this.Field = this.Field.bind(this);
      this.handleCompanyInput = this.handleCompanyInput.bind(this);

    }

    componentDidMount(){
      if(!this.props.countryDataLoaded) {
        this.props.loadCountries();
      }
    }
    
    handleCompanySelected = (company) => {
      this.setState({companyDescription: company.description});
    }

    handleCompanyInput(value) {
      let self = this;
      this.setState({
        companyName: value
      });
      fetchWithAuth(`${EndpointURL}admin/companies?name=${value}&limit=5`)
      .then(companies => companies.json())
      .then(companies => {
        self.setState({
          companyOptions: companies
        });
      });
    }

    Field({propName, label, ...props}){
      return (
        <TextField {...props}
          floatingLabelText={label} 
          value={this.state[propName]} 
          onChange={(e)=> this.setState({[propName]: e.target.value})}
          errorText={this.state[`${propName}ValidationError`]}
        />
      );
    }

    handleCountryInput = (selected) => {
      this.setState({
        countryCode: selected.Code
      })
    }

     handleStateInput = (selected) => {
      this.setState({
        stateCode: selected.Code
      })
    }

    render() {

      const styles = {
        section: {
          margin: 20
        },
        prefixIcon: {
          position:'relative',
          top: 8,
          marginRight: 3
        }
      }
      
      const currentCountry = this.props.countryData.find(cd=>cd.Code === this.state.countryCode);
     
      return (<Card> 
          <CardHeader
            title="Add a Restaurant"
            subtitle="(Discovery Feature)"
          />
          <CardText>
            <AutoComplete dataSource={this.state.companyOptions} onUpdateInput={this.handleCompanyInput} fullWidth={true} onNewRequest={this.handleCompanySelected} dataSourceConfig={{text:'name', value: 'name'}} floatingLabelText="Company Name*"/><br/>
            <this.Field propName="companyDescription" label="Company Description" fullWidth={true}/><br/>
            <this.Field propName="name" label="Location Name*" fullWidth={true}/><br/>
            <this.Field propName="description" label="Location Description" fullWidth={true}/><br/>
            <PhoneIcon style={styles.prefixIcon}/><this.Field propName="phoneNumber" label="Phone Number*"/><br/>
          </CardText>
            <CardHeader title={<span><DetailsIcon style={styles.prefixIcon}/>Address Details</span>}/>
            <CardText>
              <Section>
                <this.Field propName="streetAddress1" label="Street Addresss*" fullWidth={true}/><br/>
                <this.Field propName="city" label="City*" fullWidth={true}/><br/>
                
                <this.Field propName="zip" label="Postal Code*"/><br/>

                {this.props.countryData && this.props.countryData.length > 0? 
                  <AutoComplete dataSource={this.props.countryData} onNewRequest={this.handleCountryInput} dataSourceConfig={{text:'Name', value: 'Code'}} floatingLabelText="Country*"/>
                  : null } <br/>
                
                <AutoComplete disabled={!currentCountry} dataSource={currentCountry? currentCountry.States: []} onNewRequest={this.handleStateInput} dataSourceConfig={{text:'Name', value: 'Code'}} floatingLabelText="State / Provice*"/>
                  
              </Section>
            </CardText>
            <CardHeader title={<span><PinDrop style={styles.prefixIcon}/>Geographic Location</span>}/>
            <CardText>
              <Section>
                <this.Field propName="latitude" label="Latitude"/><br/>
                <this.Field propName="longitude" label="Longitude"/><br/>
              </Section>
            </CardText>
            <CardHeader title={<span><ContentLinkIcon style={styles.prefixIcon}/>External Links</span>}/>
            <CardText>
              <Section>
                <this.Field propName="menuUrl" label="Link to Menu" fullWidth={true}/><br/>
                <this.Field propName="websiteUrl" label="Website URL" fullWidth={true}/><br/>
                <this.Field propName="reservationUrl" label="Reservation URL" fullWidth={true}/><br/>
                <this.Field propName="hours" label="Operating Hours" fullWidth={true}/><br/>
              </Section>
            </CardText>
            <CardActions>
              <RaisedButton primary={true} label="Add" onClick={() => this.props.addRestaurant(this.state)}/>
            </CardActions>
         
        </Card>
      );
    }
}
const mapStateToProps = ({referenceData}) => ({
  countryDataLoaded: referenceData.countriesLoaded,
  countryDataLoading: referenceData.fetchInProgress,
  countryData: referenceData.countries
});

const mapDispatchToProps = (dispatch) => ({
  addRestaurant: (restaurantData) => dispatch(AddLocationEpic(restaurantData)),
  loadCountries: () => dispatch(LoadCountriesEpic())
});


const Section = (props) => (<div style={{marginLeft: 30}}>{props.children}</div>);

export default connect(mapStateToProps, mapDispatchToProps)(AddRestaurant);


// WEBPACK FOOTER //
// ./src/containers/Locations/AddRestaurant.js